<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100 no-scroll">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<comp-mst-search-container ref="searchContainer" :scrId="scrId"></comp-mst-search-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-14">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<comp-mst-table-container ref="tableContainer" @Refresh="Refresh" :scrId="scrId"></comp-mst-table-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-6">
				<!-- <table-master-info :scrId="scrId" @OpenPopup="OpenPopup"></table-master-info> -->
				<comp-mst-table-master-info
					ref="tablemasterinfo"
					@SendData="sendData"
					:scrId="scrId"
					@Refresh="Refresh"
				></comp-mst-table-master-info>
			</div>
		</div>
	</div>
</template>

<script>
import CompMstSearchContainer from './Search/CompMstSearchContainer.vue';
import CompMstTableContainer from './Table/CompMstTableContainer.vue';
import CompMstTableMasterInfo from './Table/CompMstTableMasterInfo.vue';
// import Variable from './Variable/Variable.vue';
// import Table2Container from './Table/Table2Container.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			faivorite: true,
			screen: {}
		};
	},
	components: {
		CompMstSearchContainer,
		CompMstTableContainer,
		CompMstTableMasterInfo
	},
	methods: {
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.searchContainer.searchList();
		},
		sendData(param) {
			this.sendParam = param;
		}
	}
};
</script>

<style></style>
